<template>
	<section
		class="hero"
		:class="{ loaded: isLoaded }"
	>
		<div class="hero-bg"></div>
		<div class="hero-scrim"></div>

		<div class="hero-content">
			<div>
				<div class="invite-badge">ACCESS GRANTED &mdash; VERIFIED MEMBER</div>

				<div
					class="headline-block"
					ref="headlineBlock"
				>
					<div class="headline-wrap"><h1 class="headline">Angry Bird</h1></div>
					<div class="headline-wrap"><h1 class="headline line2">Diners Club</h1></div>
				</div>

				<div class="powered-by">
					<span
						class="rule"
						ref="rule"
					></span>
					<span
						class="powered-text"
						ref="poweredText"
						>POWERED BY <b>QUILL</b></span
					>
					<img
						ref="poweredLogo"
						src="../assets/images/QUILL-LOGO-WHITE.png"
						alt="Quill"
					/>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'HomePage',
	data() {
		return {
			isLoaded: false,
		};
	},
	mounted() {
		requestAnimationFrame(() => {
			this.isLoaded = true;
		});
		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(this.syncPoweredByWidth);
		}
		window.addEventListener('resize', this.syncPoweredByWidth);
		this.syncPoweredByWidth();
		setTimeout(this.syncPoweredByWidth, 300);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.syncPoweredByWidth);
	},
	methods: {
		syncPoweredByWidth() {
			const { headlineBlock, rule, poweredText, poweredLogo } = this.$refs;
			if (!headlineBlock || !rule || !poweredText || !poweredLogo) return;
			const targetWidth = headlineBlock.getBoundingClientRect().width;
			const gap = 16;
			const usedWidth =
				poweredText.getBoundingClientRect().width + poweredLogo.getBoundingClientRect().width + gap * 2;
			const ruleWidth = Math.max(24, targetWidth - usedWidth);
			rule.style.width = ruleWidth + 'px';
		},
	},
};
</script>

<style scoped>
.hero {
	position: relative;
	width: 100%;
	height: 100vh;
	min-height: 640px;
	overflow: hidden;
}
.hero-bg {
	position: absolute;
	inset: 0;
	background-image: url('../assets/images/BACKGROUND.png');
	background-size: cover;
	background-position: center;
	transform: scale(1.08);
	filter: brightness(1.05) saturate(1.05) contrast(1.02);
	transition: transform 6s cubic-bezier(0.16, 0.8, 0.24, 1);
}
.hero.loaded .hero-bg {
	transform: scale(1);
}
.hero-scrim {
	position: absolute;
	inset: 0;
	background: linear-gradient(100deg, rgba(4, 4, 5, 0.5) 0%, rgba(4, 4, 5, 0.2) 38%, rgba(4, 4, 5, 0.02) 62%);
	z-index: 2;
}

.hero-content {
	position: relative;
	z-index: 10;
	height: 100%;
	display: flex;
	align-items: center;
	padding: 0 48px;
	max-width: 1400px;
	margin: 0 auto;
}

.invite-badge {
	display: inline-flex;
	align-items: center;
	gap: 10px;
	font-size: 11px;
	letter-spacing: 0.22em;
	color: var(--ink-dim);
	margin-bottom: 28px;
	opacity: 0;
	transform: translateY(10px);
	animation: reveal-up 1s cubic-bezier(0.16, 0.8, 0.24, 1) forwards;
	animation-delay: 1.4s;
}
.invite-badge::before {
	content: '';
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: var(--blood-bright);
	box-shadow: 0 0 8px 2px rgba(163, 32, 32, 0.6);
	flex-shrink: 0;
}

.headline-block {
	display: block;
}
.headline-wrap {
	overflow: hidden;
}
.headline {
	font-family: 'Dead Revolution', 'Georgia', serif;
	font-weight: 400;
	font-style: normal;
	font-size: clamp(2.6rem, 6.6vw, 5.2rem);
	line-height: 1.02;
	letter-spacing: 0.01em;
	text-transform: uppercase;
	color: var(--ink);
	transform: translateY(110%);
	animation: reveal-up 1.1s cubic-bezier(0.16, 0.8, 0.24, 1) forwards;
}
.headline:nth-of-type(1) {
	animation-delay: 0.15s;
}
.headline.line2 {
	animation-delay: 0.3s;
}

@keyframes reveal-up {
	to {
		transform: translateY(0);
		opacity: 1;
	}
}

.powered-by {
	margin-top: 32px;
	display: flex;
	align-items: center;
	gap: 16px;
	opacity: 0;
	animation: reveal-up 1s cubic-bezier(0.16, 0.8, 0.24, 1) forwards;
	animation-delay: 0.75s;
}
.powered-by .rule {
	flex: 0 0 auto;
	width: 48px;
	height: 2px;
	background: var(--ink-dim);
}
.powered-by span {
	font-size: 15px;
	letter-spacing: 0.2em;
	color: var(--ink-dim);
	font-weight: 500;
	flex-shrink: 0;
}
.powered-by b {
	color: var(--ink);
	font-weight: 600;
}
.powered-by img {
	height: 34px;
	width: auto;
	opacity: 1;
	flex-shrink: 0;
}

@media (max-width: 900px) {
	.hero-content {
		padding: 0 24px;
	}
	.hero-scrim {
		background: linear-gradient(180deg, rgba(4, 4, 5, 0.55) 0%, rgba(4, 4, 5, 0.55) 55%, rgba(4, 4, 5, 0.92) 100%);
	}
	.headline {
		font-size: clamp(2.1rem, 10vw, 3.2rem);
	}
	.powered-by span {
		font-size: 13px;
	}
	.powered-by img {
		height: 26px;
	}
}
</style>
